import PagesAPI, {
  IMPRINT_PAGE_ID,
  PRIVACY_POLICY_PAGE_ID,
  TERMS_OF_SERVICE_PAGE_ID,
} from '@/modules/pages/api/pages'

export default {
  updatePages({ commit }) {
    return PagesAPI.getPages().then((data) => {
      const keyedPages = {}
      data.pages.forEach((page) => {
        keyedPages[page.id] = page
      })
      commit('setPagesList', keyedPages)
    })
  },
  findPage({ commit, rootGetters }, id) {
    if ([IMPRINT_PAGE_ID, PRIVACY_POLICY_PAGE_ID, TERMS_OF_SERVICE_PAGE_ID].includes(id)) {
      const profileId = rootGetters['auth/profileId']
      return PagesAPI.findPublicPage(id, profileId).then((data) => {
        commit('setPage', { data, id })
      }).catch((error) => {
        commit('setPage', { data: null, id })
        throw error
      })
    }
    return PagesAPI.findPage(id).then((data) => {
      commit('setPage', { data, id })
    }).catch((error) => {
      commit('setPage', { data: null, id })
      throw error
    })
  },
  findPublicPage({ commit, rootGetters }, payload) {
    const id = typeof payload === 'object' ? payload.id : payload
    const profileId = (typeof payload === 'object' && payload.profileId) ? payload.profileId : rootGetters['auth/profileId']
    const cacheKey = profileId ? `${id}:${profileId}` : id
    return PagesAPI.findPublicPage(id, profileId).then((data) => {
      commit('setPublicPage', { data, id: cacheKey })
    }).catch((error) => {
      commit('setPublicPage', { data: null, id: cacheKey })
      throw error
    })
  },
  loadTos({ commit }) {
    return PagesAPI.getTos().then((data) => {
      commit('setTos', { data })
      return data
    }).catch((error) => {
      commit('setTos', { data: null })
      throw error
    })
  },
  loadPrivacyPolicyForConfirmation({ commit }) {
    return PagesAPI.getPrivacyPolicyForConfirmation().then((data) => {
      commit('setPrivacyPolicyForConfirmation', { data })
      return data
    }).catch((error) => {
      commit('setPrivacyPolicyForConfirmation', { data: null })
      throw error
    })
  },
}
